const state = {
    endpoint: "/mail",
}

const getters = {

}

const actions = {
    async sendMail(_, mailData) {
        console.log(mailData);
        try {
            this._vm.$directus.api.post(state.endpoint, mailData, {} );
        } catch(error) {
            console.log(error);
            throw error;
        }
    },

}

const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};